import { render } from "./baseCheckbox.vue?vue&type=template&id=336d5526"
import script from "./baseCheckbox.vue?vue&type=script&lang=js"
export * from "./baseCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__